import React, {useState } from "react";
import I18n from 'i18n.js.erb'
import PlaceholderImage from "./PlaceholderImage.jsx"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import {
  displayTranslations,
  getArtwork,
  parseBlueprintImageNameAndEdition,
  parseCategoryName
} from "../../utils/utils";
import TextOverlayOnImage from "./TextOverlayOnImage";

const SealedProductListItem = ({
  blueprintImage,
  onCheckHandler,
  onKeyDownQuantity,
  onChangeQuantity,
  handleNavigation,
  era_index,
  era_name,
  blueprint_image_index,
  languages,
}) => {


  const [isSmallDesktop, setIsSmallDesktop] = useState(false)


  $(window).resize(function () {
    if ($(window).innerWidth() < 1400 && !isSmallDesktop) {
      setIsSmallDesktop(true)
    }
    if ($(window).innerWidth() > 1400 && isSmallDesktop) {
      setIsSmallDesktop(false)
    }
  });


  const blueprintImageNames = displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language)

  return <div key={blueprintImage.id}
    className="row m-2 p-sm-1 col-12 text-center ml-0-imp"
    data-id={blueprintImage.id}
    style={ blueprintImage.checked ?
      {
        backgroundColor: "#e8e8e847",
        border: "1px solid #000000",
        boxShadow: "5px 5px 5px rgba(68, 68, 68, 0.6)",
      }
      :  {}
    } >


    <label htmlFor={blueprintImage.id}
      className={`custom-header-list col-11 m-auto pt-20px pb-10px pl-30px ${blueprintImage.encasing_id && 'cursor-pointer'}`}
    >
     <div className="row w-100">
       <div className={`${ isSmallDesktop ? 'col-12' : 'col-4'} pl-0 position-relative`}>
         <p className="position-absolute container-language-of-product-icon">
           <img src={window.location.origin + `/images/flags/${blueprintImage.language}.png`}
                style={{ maxHeight: "20px"}} alt=""/>
         </p>
         {
           blueprintImage.expansion_icon_url &&
             <p className="position-absolute container-expansion-icon-of-product-icon">
               <img src={blueprintImage.expansion_icon_url}
                    style={{ height: "30px", minHeight: "20px" }} alt=""/>
             </p>
         }

         <div className="d-flex justify-content-center position-relative text-center"
              style={{ maxHeight: '150px', maxWidth: '100px' }}>
           {
             blueprintImage.medium_image_url ?
               <React.Fragment>
                 <img
                   className="image-card-list rounded"
                   style={{borderRadius: "7px"}}
                   src={blueprintImage.medium_image_url}
                   alt=""
                 />

                 {
                   !blueprintImage.encasing_id &&
                   <TextOverlayOnImage
                     textOverlay={I18n.t('js.common.notGradableProduct')}
                     size={'thumb'}
                     type={'red-overlay'}
                   />
                 }
               </React.Fragment>
             :
               <PlaceholderImage
                 size={'medium'}
                 overlaySize={'thumb'}
                 additionalClasses={'image-card-list'}
                 textOverlay={getArtwork(blueprintImage)}
                 showNotGradableProductOverlay={!blueprintImage.encasing_id}
               />
           }
         </div>
       </div>

       <div className={`${isSmallDesktop ? 'col-12' : 'col-8'} text-weight-500`} >
         <div className="row">
           <div id={"blueprint_image_metaname_" + blueprintImage.id} className="col-12 p-0">
             {
               blueprintImageNames.length > 1 ? (
                 <div className="text-dark noselect">
                   <p>
                     {
                       parseBlueprintImageNameAndEdition(blueprintImage.game_name, blueprintImage.edition, blueprintImageNames[0])
                     }
                   </p>
                   <p className="d-none d-md-block">
                     { blueprintImageNames[1] }
                   </p>
                 </div>
             ) : (
               <div className="text-dark noselect d-none d-md-block">
                 <p className="mr-3">
                   {
                     blueprintImageNames[0] +
                      (blueprintImage.game_name !== 'Pokémon' && blueprintImage.edition &&
                      blueprintImageNames[0].toLowerCase().indexOf(blueprintImage.edition.toString().toLowerCase() === '1 edition' ? (blueprintImage.language === 'en' ? '1st edition' : '1a edizione') : blueprintImage.edition.toString().toLowerCase()) === -1 &&
                          !['', 'undefined'].includes(blueprintImage.edition.toString().toLowerCase()) ? ' - ' + blueprintImage.edition : '')
                   }
                 </p>
               </div>
             )}

             {
               getArtwork(blueprintImage) ? <p><small>[{getArtwork(blueprintImage)}]</small></p> : <React.Fragment></React.Fragment>
             }

           </div>
         </div>

         <div className="row mt-30px">
           <div className="col-12">
             <div className="d-flex flex-wrap justify-content-center w-100">
               <button id={"product_info_" + blueprintImage.id}
                       className="btn btn-dark text-light btn-sm rounded noselect align-self-center w-100"
                       onClick={(e) => handleNavigation(e, blueprintImage, `/blueprint_images/${blueprintImage.id}`)}>
                 {I18n.t('js.indexSealedPage.productInfo')}
               </button>
               <div className="ro">

               </div>
               { blueprintImage.already_in_wishlist > 0 &&
               <p className="w-100 mt-10px mb-0">
                 {I18n.t('js.common.thisCardIn')} &nbsp;
                 <span className="data-structure-link"
                       style={{ cursor: 'pointer', color: "inherit" }}
                       onClick={ (e) => handleNavigation(e, null, `/wishlists/${blueprintImage.already_in_wishlist}/edit`) }>
                    {I18n.t('js.common.yourWishlist')}
                  </span>
               </p>
               }
             </div>
           </div>
         </div>

         <div className="row mt-30px">
           <div className="col-4">
             <p className="mb-0 ">{I18n.t('js.filters.sort.category')}:</p>
             <p>
               { parseCategoryName(blueprintImage.category_name) }
             </p>
           </div>
           <div className="col-4">
             <p className="mb-0 text--white-space-no-wrap">{I18n.t('js.filters.sort.releaseDate')}:</p>
             <p id={"release_date_" + blueprintImage.id}>{blueprintImage.released_at}</p>
           </div>
           <div className="col-4">
             <div className="noselect quantity-content mb-3">
               {
                 blueprintImage.checked &&
                 <React.Fragment>
                   <div className="noselect">
                     <p className="mb-0 text-left">{I18n.t('js.common.quantity')}:</p></div>
                   <div className="noselect">
                     <OverlayTrigger
                       placement="top"
                       overlay={
                         <Tooltip id={`tooltip-top`}>
                           <p>{I18n.t('js.common.quantityTooltipContent')}</p>
                         </Tooltip>
                       }
                     >
                       <div>
                         <input
                           className="form-control quantity-name"
                           value={blueprintImage.quantity ? blueprintImage.quantity : ''}
                           name="bluprint_image_quantity"
                           type="number"
                           style={{ width: "77px" }}
                           onKeyDown={(e) => onKeyDownQuantity(e)}
                           onClick={(e) => e.stopPropagation()}
                           onChange={(e) => onChangeQuantity(e, era_index, era_name, blueprint_image_index)}
                           data-id={blueprintImage.id}
                         />
                       </div>
                     </OverlayTrigger>
                   </div>
                 </React.Fragment>

               }
               <input type="checkbox"
                      checked={blueprintImage.checked === true}
                      id={blueprintImage.id}
                      onChange={(e) => onCheckHandler(e, blueprintImage.id)}
                      className="option-input checkbox checkbox-cards-list" />
             </div>
           </div>
         </div>
       </div>
     </div>
    </label>
  </div>
};

export default SealedProductListItem;